var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.78 43.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.544,20.169l3.333-3.333L7.459,14.418,0,21.878l7.459,7.459L9.877,26.92,6.544,23.587h9.8V20.169Zm6.385,20.168H.024v3.418H43.78V5.127A5.134,5.134,0,0,0,38.653,0h-20.6a5.134,5.134,0,0,0-5.128,5.127V16.75h3.419V5.127a1.711,1.711,0,0,1,1.709-1.709h2a5.1,5.1,0,0,0-.294,1.709v35.21H16.348V27.005H12.929Zm27.433,0H23.184V5.127a1.711,1.711,0,0,1,1.709-1.709H38.653a1.711,1.711,0,0,1,1.709,1.709ZM28.269,20.169A1.666,1.666,0,1,1,26.6,21.835,1.666,1.666,0,0,1,28.269,20.169Zm0,0",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.984db223e8246140daa273c7cd1b7438.svg";
export { ForwardRef as ReactComponent };